module.exports = __webpack_public_path__ + "img/fy11.441424fe.jpeg";